module.exports = __webpack_public_path__ + "media/36.cb6103f0.ogg";